import { render, staticRenderFns } from "./bgdRecharge.vue?vue&type=template&id=67b6e41a&scoped=true&"
import script from "./bgdRecharge.vue?vue&type=script&lang=js&"
export * from "./bgdRecharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b6e41a",
  null
  
)

export default component.exports